import React from 'react';
import { useSelector } from 'react-redux';
import { useModal } from '../_contexts';
import { Modal } from '../_components';
import { MarkerTemplateForm } from './forms';

export function MarkerTemplateEditor({ item, prevModal }) {
  const { closeModal } = useModal();
  const { details: world } = useSelector((state) => state.world);
  return (
    <Modal
      id="markerTemplateManagerModal"
      // backdrop
      title={item?._id ? 'Edit Template' : 'New Template'}
      icon=""
      size="md"
      open
      onClose={() => closeModal()}
    >
      <MarkerTemplateForm
        worldID={world._id}
        template={item}
        prevModal={prevModal}
      />
    </Modal>
  );
}
